import _classCallCheck from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10;
import { jsx as e, jsxs as t } from "react/jsx-runtime";
import { Component as o } from "react";
import i, { css as n, keyframes as r } from "styled-components";
import a from "react-focus-lock";
import { calculateRem as l, withVDSManager as s } from "@vds-core/utilities";
import { Fonts as d, Body as c } from "@vds-core/typography";
import { ColorTokens as p } from "@vds-tokens/color";
import { TypographyTokens as m } from "@vds-tokens/typography";
import u from "./TooltipDialogOverlay.js";
import f from "./TooltipPortal.js";
import h from "./util/screen-reader.js";
var g = i.div.withConfig({
  displayName: "Wrapper",
  componentId: "VDS__sc-7wisln-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 999;\n"])));
function x(e) {
  return "in" === e ? r(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0% {\n    opacity: 0;\n    transform: scale(1.2);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n"]))) : r(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  0% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n"])));
}
var y = i.div.withConfig({
    displayName: "Dialog",
    componentId: "VDS__sc-7wisln-1"
  })(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  padding-top: 16px;\n  background-color: ", ";\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column-reverse;\n  flex-flow: column-reverse nowrap;\n  justify-content: space-between;\n  min-height: ", ";\n  max-height: ", ";\n  position: relative;\n  width: ", ";\n  outline: none;\n  z-index: 1000;\n  border-radius: 12px;\n  ", ";\n\n  ", ";\n"])), function (_ref) {
    var e = _ref.surface;
    return "dark" === e ? p.background.primary.dark.value : p.background.primary.light.value;
  }, l(96), l(312), l(296), function (_ref2) {
    var e = _ref2.dialogOpened,
      t = _ref2.disableAnimation;
    return e && !t && n(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      animation: 0.2s cubic-bezier(0.37, 0, 0.63, 1) both 0s\n        ", ";\n    "])), x("in"));
  }, function (_ref3) {
    var e = _ref3.$unmounted,
      t = _ref3.disableAnimation;
    return e && !t && n(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      animation: 0.1s cubic-bezier(0.37, 0, 0.63, 1) both 0s\n        ", ";\n    "])), x("out"));
  }),
  v = i.span.withConfig({
    displayName: "StyledHeading",
    componentId: "VDS__sc-7wisln-2"
  })(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  max-width: 100%;\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  padding-bottom: 8px;\n  margin: 0;\n"])), function (_ref4) {
    var e = _ref4.surface;
    return "dark" === e ? p.elements.primary.ondark.value : p.elements.primary.onlight.value;
  }, d.VerizonNHGeDS, m.fontsize.title[20].value, m.lineheight.title[24].value, m.fontweight.bold.value),
  w = i.span.withConfig({
    displayName: "StyledBody",
    componentId: "VDS__sc-7wisln-3"
  })(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  letter-spacing: ", ";\n  padding-bottom: 16px;\n"])), function (_ref5) {
    var e = _ref5.surface;
    return "dark" === e ? p.elements.primary.ondark.value : p.elements.primary.onlight.value;
  }, d.VerizonNHGeDS, m.fontsize.title[16].value, m.lineheight.title[20].value, m.letterspacing.wide.value),
  b = i.div.withConfig({
    displayName: "DialogWrapper",
    componentId: "VDS__sc-7wisln-4"
  })(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  overflow-y: scroll;\n  padding: 0px 16px 0px 16px;\n  border-bottom: ", " solid\n    ", ";\n"])), l(1), function (_ref6) {
    var e = _ref6.surface;
    return "dark" === e ? p.elements.lowcontrast.ondark.value : p.elements.lowcontrast.onlight.value;
  }),
  $ = i.div.withConfig({
    displayName: "ContentContainer",
    componentId: "VDS__sc-7wisln-5"
  })(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  max-height: calc(312px - 44px - 16px - 1px);\n  word-break: break-word;\n"]))),
  k = i.button.withConfig({
    displayName: "TooltipButton",
    componentId: "VDS__sc-7wisln-6"
  })(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  height: ", ";\n  align-items: center;\n  justify-content: center;\n  background-color: transparent;\n  border: none;\n  position: relative;\n  outline: none;\n"])), l(44)),
  D = i.span.withConfig({
    displayName: "ButtonTextContainer",
    componentId: "VDS__sc-7wisln-7"
  })(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var C = /*#__PURE__*/function (_o) {
  _inherits(C, _o);
  function C(e) {
    var _this;
    _classCallCheck(this, C);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(C).call(this, e)), _this.state = {
      expandedStateText: "expanded! "
    };
    return _this;
  }
  _createClass(C, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var e = this;
      this.props.isAndroidDevice && h.OpenDialog(), setTimeout(function () {
        e.setState({
          expandedStateText: ""
        });
      }, 500);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.isAndroidDevice && h.CloseDialog();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        o = _this$props.title,
        i = _this$props.body,
        n = _this$props.onClick,
        r = _this$props.surface,
        l = _this$props.closeButtonText,
        s = _this$props.dialogOpened,
        d = _this$props.unmounted,
        m = _this$props.dialogId;
      return e(f, {
        children: e(g, {
          children: e(a, {
            disabled: !1,
            returnFocus: !0,
            children: e(u, {
              dialogOpened: s,
              opened: s,
              surface: r,
              viewport: "desktop",
              unmounted: d,
              children: t(y, {
                surface: r,
                $dialogOpened: s,
                $unmounted: d,
                id: m,
                role: "dialog",
                "aria-modal": !0,
                children: [e(k, {
                  surface: r,
                  onClick: n,
                  "aria-label": "".concat(this.state.expandedStateText).concat(l),
                  children: e(D, {
                    children: e(c, {
                      size: "large",
                      viewport: "mobile",
                      color: "dark" === r ? p.elements.primary.ondark.value : p.elements.primary.onlight.value,
                      children: l
                    })
                  })
                }), e(b, {
                  surface: r,
                  children: t($, {
                    children: [!!o && e(v, {
                      surface: r,
                      children: o
                    }), e(w, {
                      surface: r,
                      children: i
                    })]
                  })
                })]
              })
            })
          })
        })
      });
    }
  }]);
  return C;
}(o);
C.defaultProps = {
  onClick: void 0,
  closeButtonText: "Close"
};
var S = s(C);
export { S as default };